import { useEffect, useState } from "react";
import { api, formatApiError } from "../api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, Mail, Trash2, Check } from "lucide-react";
import { toast } from "sonner";

export default function MessagesAdmin() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/api/admin/messages");
      setItems(data);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try {
      await api.put(`/api/admin/messages/${id}/read`);
      setItems((arr) => arr.map((x) => (x.id === id ? { ...x, read: true } : x)));
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    try {
      await api.delete(`/api/admin/messages/${id}`);
      setItems((arr) => arr.filter((x) => x.id !== id));
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-6" data-testid="messages-page">
      <div>
        <h1 className="text-3xl font-serif font-bold">Contact Messages</h1>
        <p className="text-sm text-muted-foreground mt-1">Visitor submissions from the contact form.</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>
      ) : items.length === 0 ? (
        <Card className="p-10 text-center text-muted-foreground">No messages.</Card>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <Card key={m.id} className={`p-4 ${!m.read ? "border-primary/50 bg-primary/5" : ""}`} data-testid={`message-${m.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-medium">{m.name}</span>
                    <span className="text-xs text-muted-foreground">&lt;{m.email}&gt;</span>
                    {!m.read && <span className="text-[10px] bg-primary text-white px-1.5 py-0.5 rounded-full">NEW</span>}
                  </div>
                  {m.subject && <div className="text-sm font-medium mt-1">{m.subject}</div>}
                  <p className="text-sm text-muted-foreground mt-2 whitespace-pre-wrap">{m.message}</p>
                  <div className="text-xs text-muted-foreground mt-2">{new Date(m.created_at).toLocaleString()}</div>
                </div>
                <div className="flex flex-col gap-1">
                  {!m.read && (
                    <Button size="sm" variant="outline" onClick={() => markRead(m.id)} title="Mark read">
                      <Check className="w-3 h-3" />
                    </Button>
                  )}
                  <Button size="sm" variant="outline" className="text-destructive" onClick={() => remove(m.id)}>
                    <Trash2 className="w-3 h-3" />
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
